module.exports = __webpack_public_path__ + "img/AVETWCLogo.344b4cfb.svg";